// extracted by mini-css-extract-plugin
module.exports = {"scroll_text":"ScrollText_scroll_text__FdxWh"};